export const Marquee = () => {
  const items = ["Connexa Home", "Connexa Auto", "Tu desideri", "Noi realizziamo"];
  const row = [...items, ...items, ...items, ...items];
  return (
    <div
      data-testid="marquee-ribbon"
      className="relative overflow-hidden border-y border-[var(--cx-border)] bg-[var(--cx-anthracite)] py-6 md:py-8"
    >
      <div className="cx-marquee-track">
        {row.map((t, i) => (
          <span key={i} className="mx-8 flex items-center font-display text-3xl md:text-5xl font-light text-[var(--cx-white)]/70">
            {t}
            <span className="mx-8 text-[var(--cx-gold)]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
